/**
 * 求人プールからの削除 (BTN-M-014) と、求人プールに無い求人の枠 (画面レイアウト_SCR-M-001.md §4.4・§6.2、Issue #883)
 * の判定。状態を持たない関数だけを置く。
 */

// 枠の文言 (§4.4「求人プールに無い求人の枠」)
export const MISSING_FROM_POOL_TITLE = 'この求人は求人プールにありません。';
export const MISSING_FROM_POOL_NOTE = '削除されたか、求人票が置き換えられたため、推薦 PDF には載りません。';

/**
 * 「削除」(BTN-M-014) を出すか。テナントのマネージャー (`is_admin`) か、その案件の担当者 (案件の `owner_id`)
 * のときだけ出す (§6.2「BTN-M-014 を出す条件」。マネージャーの定義は CRUD 図 §4.1)。
 * 利用者・案件がまだ取れていない間は出さない (サーバも同じ条件で検査し、外れれば 403)。
 *
 * @param {{id?: string, is_admin?: boolean}|null|undefined} currentUser `/auth/me` の利用者
 * @param {{owner_id?: string}|null|undefined} opportunity `/opportunities/{id}` の案件
 * @returns {boolean}
 */
export function canDeleteFromJobPool(currentUser, opportunity) {
    if (!currentUser) return false;
    if (currentUser.is_admin === true) return true;
    return Boolean(currentUser.id) && opportunity?.owner_id === currentUser.id;
}

/**
 * 推薦カードを「求人プールに無い求人の枠」として出すか。一覧 (DP-M-009) の取得に成功しているのに、
 * その求人が一覧に無いときだけ真 (§4.4)。一覧の取得に失敗している間は、どの求人が消えたかを
 * 判断できないため偽にする (カードは「求人の情報を取得できませんでした。…」を出す)。
 *
 * @param {{jobPoolItem?: object|null}} item 画面の並びの要素
 * @param {boolean} jobPoolLoaded 一覧の取得に成功しているか
 * @returns {boolean}
 */
export function isMissingFromJobPool(item, jobPoolLoaded) {
    return jobPoolLoaded && !item.jobPoolItem;
}

/**
 * 画面に出す順位。枠を数えずに、ほかのカードだけで 1 から振る (§4.4「順位の番号」。推薦 PDF と同じ番号になる)。
 * 枠の位置は null。並びの順 (item.rank) は変えない (並べ替えの保存は ID の並びで送るため)。
 *
 * @param {object[]} items 画面の並び
 * @param {boolean} jobPoolLoaded
 * @returns {(number|null)[]} items と同じ長さ
 */
export function displayRanks(items, jobPoolLoaded) {
    let rank = 0;
    return items.map((item) => (isMissingFromJobPool(item, jobPoolLoaded) ? null : ++rank));
}
